export default [
  {
    value: '+358',
    code: 'FI',
  },
  {
    value: '+46',
    code: 'SE',
  },
  {
    value: '+49',
    code: 'DE',
  },
];
